module.exports = __webpack_public_path__ + "img/3.b8928273.jpg";